import { render, staticRenderFns } from "./FieldsDetails.vue?vue&type=template&id=064d88a7&scoped=true"
import script from "./FieldsDetails.vue?vue&type=script&lang=js"
export * from "./FieldsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d88a7",
  null
  
)

export default component.exports